import { createContext, useContext, useState } from 'react';
import { NotificationMessage } from '../Components/NotificationMessage';

const NotificationContext = createContext({});

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        type: 'info',
        message: '',
        show: false,
    });

    const handleCloseNotification = () => {
        setNotification((prev) => ({ ...prev, show: false }));
    };

    const id = crypto.randomUUID();

    return (
        <NotificationContext.Provider value={{ setNotification }}>
            {children}

            {notification && notification.show && (
                <NotificationMessage
                    key={id}
                    type={notification.type}
                    message={notification.message}
                    show={notification.show}
                    onClose={handleCloseNotification}
                />
            )}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
